import { useEffect, useState } from "react";
import { logger, sanitizeError } from "../../utils/logger.js";
import { loadProposalCompany } from "./loadProposalCompany";

/**
 * Company, sector, and address state for one proposal.
 * The details page logs the proposal and each lookup. The modal does not.
 * The modal also skips the request when the proposal has no user id.
 * The page still calls the loader in that case, matching its previous effect.
 * Dependency list stays navigate plus the user id. Other proposal fields do not refetch.
 */
export const useProposalCompany = ({
  userId,
  navigate,
  proposalForLog = null,
  logProposal = false,
  requireUserId = false,
}) => {
  const [company, setCompany] = useState(null);
  const [sector, setSector] = useState(null);
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);
  const [town, setTown] = useState(null);
  const [zipCode, setZipCode] = useState(null);
  const [neighborhood, setNeighborhood] = useState(null);

  useEffect(() => {
    if (logProposal) {
      logger.info("proposal", { data: proposalForLog });
    }
    const token = localStorage.getItem("token");
    const tokenMissing = !token || token.trim() === "undefined";
    if (tokenMissing || (requireUserId && !userId)) {
      return;
    }

    const fetchData = async () => {
      try {
        await loadProposalCompany({
          userId,
          navigate,
          setCompany,
          setSector,
          setCountry,
          setState,
          setTown,
          setZipCode,
          setNeighborhood,
          logSteps: logProposal,
        });
      } catch (error) {
        logger.error("Error fetching proposal data:", {
          err: sanitizeError(error),
        });
      }
    };
    fetchData();
    // proposalForLog is read for the same log the page emitted, without refetching on every field change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, userId]);

  return {
    company,
    country,
    neighborhood,
    sector,
    state,
    town,
    zipCode,
  };
};
